import { render } from "./Mount.vue?vue&type=template&id=4c383e8f"
import script from "./Mount.vue?vue&type=script&lang=js"
export * from "./Mount.vue?vue&type=script&lang=js"

import "./Mount.vue?vue&type=style&index=0&id=4c383e8f&lang=scss"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__